var React = require('react');
var Extras = require('../../../data/extras.json');

var Stamper = require('./Stamper');

var createSprite = require('../../../lib/createSprite');
var Utils = require('../../../lib/utils');

var PuppetsMaster = React.createClass({

    propTypes: {
        index: React.PropTypes.number,
        play: React.PropTypes.bool,
        storyWidth: React.PropTypes.number,
        storyHeight: React.PropTypes.number,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        border: React.PropTypes.number,
        objs: React.PropTypes.object,
        container: React.PropTypes.object,
        backgroundKey: React.PropTypes.string,
        movieclipKey: React.PropTypes.string,
        titles: React.PropTypes.array,
        roles: React.PropTypes.array,
    },

    contextTypes: {
        language: React.PropTypes.string,
    },

    getDefaultProps: function()
    {
        return {
            texts: [
                {
                    title: 'RON FORSYTHE',
                    subtitle: 'Banquier d\'investissement',
                    opts: {
                        align: 'right',
                        titleStyle: {
                            fill: '#FFFFFF'
                        },
                        subtitleStyle: {
                            fill: '#FFFFFF'
                        },
                        color: '#FFF',
                        x: 1030,
                        y: 140,
                    }
                },
                {
                    title: 'Sandra Li',
                    subtitle: 'Gestionnaire\nde contrôle',
                    opts: {
                        align: 'right',
                        x: 1030,
                        y: 500,
                        croppedY: 500,
                    }
                }
            ],
            backgroundKey: 'puppetsMasterBg',
            className: 'puppets-master',
            movieclipKey: 'puppetsMaster',
            blobsRow: 1,
            showBottomTreadmill: false,

            titles: ['ron', 'sandra'],
            roles: ['ron_title', 'sandra_title'],
        }
    },

    render: function()
    {
        const texts = this.props.texts.map((text, idx) => {
            return _.merge(text,
                {
                    title: Extras[this.props.titles[idx]].text[this.context.language],
                    subtitle: Extras[this.props.roles[idx]].text[this.context.language],
                },
            );
        });

        return (
            <Stamper
                onBeforeObjectsBuild={this.onBeforeObjectsBuild}
                {...this.props}
                texts={texts}
            />
        );
    },

    onBeforeObjectsBuild: function(container, timeline)
    {
        var props = this.props;
        var objs = props.objs;

        var diplomeObj = objs.diplomePuppetsMaster;
        var diplome = createSprite(diplomeObj);
        Utils.setSizeAndPositionFromRefSize(diplome, props.width, props.height, diplomeObj);
        container.addChild(diplome);
    }
});

module.exports = PuppetsMaster;



// WEBPACK FOOTER //
// ./js/components/frames/_common/PuppetsMaster.jsx